import { Component, Input } from '@angular/core';
import { sortBy } from 'src/app/services/helpers/utils';

@Component({
  selector: 'ng-closet-doors-standard-summary',
  templateUrl: './summary.component.html',
})
export class ClosetDoorsStandardSummaryComponent {
  //Objet récapitulatif
  @Input() resume: any;

  constructor() {}

  getStructures() {
    let structures = [];
    this.resume.panel.doors.forEach(door => {
      if (structures.some(s => s.description === door.doorTypeFr)) {
        let indexStructure = structures.indexOf(structures.filter(s => s.description === door.doorTypeFr)[0]);
        structures[indexStructure].count = structures[indexStructure].count + 1;
      } else {
        structures.push({
          description: door.doorTypeFr,
          count: 1,
        });
      }
    });
    return structures;
  }

  sortedDoors() {
    return sortBy(this.resume.panel.doors, d => d.index);
  }
}
